<template>
  <ul class="student-style flex-align-between" >
        <li class="style-li" 
            v-for="(item, index) in list" 
            :key="index"
            :style="marginBottom"
            :class="calcStyle">
            <img src="" alt="">
            <p class="wes">{{item.name}}</p>
        </li>
  </ul>
</template>

<script>
export default {
    props: {
        cloumn: {
          type:Number
        },
        margin:{
          type:Number
        }
    },
    data() {
        return {
            marginBottom:{
                marginBottom: this.margin ? this.margin+'px' : 0
            },
            list:[{
                imgURL:'',
                name:'凌小玲试炼公开课精彩片段小玲试炼小玲试炼小玲试炼小玲试炼'
            },{
                imgURL:'',
                name:'凌小玲试炼公开课精彩片段'
            },{
                imgURL:'',
                name:'凌小玲试炼公开课精彩片段'
            },{
                imgURL:'',
                name:'凌小玲试炼公开课精彩片段'
            },{
                imgURL:'',
                name:'凌小玲试炼公开课精彩片段'
            }],
        }
    },
    computed:{
        calcStyle:function() {
            let lof = 'u-lof'
            this.cloumn ? lof = 'u-lof' + String(this.cloumn) : lof = lof +'4'
            return lof;
        }
    }

}
</script>

<style lang="less" scoped>
    .student-style {
        flex-flow: row wrap;
        align-content: flex-start;

        .u-lof4 {
            flex: 0 0 24%;
            max-width: 24%;
        }

        .u-lof3 {
            flex: 0 0 33%;
            max-width: 33%;
        }

        .u-lof2 {
            flex: 0 0 49%;
            max-width: 49%;
        }
        
        img {
            display: block;

            width: 100%;
            height: 161px;

            background-color: #1c4b90;
        }
        p {
            padding: 20px;

            font-size: 16px;

            color: #333;
        }

        
    }
</style>